{
  "nodes": [
    {
      "id": 0,
      "betriebspunktName": "BN",
      "fullName": "Bern",
      "positionX": -192,
      "positionY": 32,
      "ports": [],
      "transitions": [],
      "connections": [],
      "resourceId": 1,
      "perronkanten": 10,
      "connectionTime": 5,
      "trainrunCategoryHaltezeiten": {
        "HaltezeitIPV": {"haltezeit": 3, "no_halt": false},
        "HaltezeitA": {"haltezeit": 2, "no_halt": false},
        "HaltezeitB": {"haltezeit": 2, "no_halt": false},
        "HaltezeitC": {"haltezeit": 1, "no_halt": false},
        "HaltezeitD": {"haltezeit": 1, "no_halt": false},
        "HaltezeitUncategorized": {"haltezeit": 0, "no_halt": true}
      },
      "symmetryAxis": 0,
      "warnings": null,
      "labelIds": []
    },
    {
      "id": 1,
      "betriebspunktName": "OL",
      "fullName": "Olten",
      "positionX": 832,
      "positionY": 32,
      "ports": [],
      "transitions": [],
      "connections": [],
      "resourceId": 2,
      "perronkanten": 10,
      "connectionTime": 5,
      "trainrunCategoryHaltezeiten": {
        "HaltezeitIPV": {"haltezeit": 3, "no_halt": false},
        "HaltezeitA": {"haltezeit": 2, "no_halt": false},
        "HaltezeitB": {"haltezeit": 2, "no_halt": false},
        "HaltezeitC": {"haltezeit": 1, "no_halt": false},
        "HaltezeitD": {"haltezeit": 1, "no_halt": false},
        "HaltezeitUncategorized": {"haltezeit": 0, "no_halt": true}
      },
      "symmetryAxis": null,
      "warnings": null,
      "labelIds": []
    },
    {
      "id": 2,
      "betriebspunktName": "ZUE",
      "fullName": "Zuerich",
      "positionX": 1632,
      "positionY": 32,
      "ports": [],
      "transitions": [],
      "connections": [],
      "resourceId": 3,
      "perronkanten": 10,
      "connectionTime": 5,
      "trainrunCategoryHaltezeiten": {
        "HaltezeitIPV": {"haltezeit": 3, "no_halt": false},
        "HaltezeitA": {"haltezeit": 2, "no_halt": false},
        "HaltezeitB": {"haltezeit": 2, "no_halt": false},
        "HaltezeitC": {"haltezeit": 1, "no_halt": false},
        "HaltezeitD": {"haltezeit": 1, "no_halt": false},
        "HaltezeitUncategorized": {"haltezeit": 0, "no_halt": true}
      },
      "symmetryAxis": null,
      "warnings": null,
      "labelIds": []
    },
    {
      "id": 3,
      "betriebspunktName": "LZ",
      "fullName": "Luzern",
      "positionX": 1184,
      "positionY": 960,
      "ports": [],
      "transitions": [],
      "connections": [],
      "resourceId": 4,
      "perronkanten": 10,
      "connectionTime": 5,
      "trainrunCategoryHaltezeiten": {
        "HaltezeitIPV": {"haltezeit": 3, "no_halt": false},
        "HaltezeitA": {"haltezeit": 2, "no_halt": false},
        "HaltezeitB": {"haltezeit": 2, "no_halt": false},
        "HaltezeitC": {"haltezeit": 1, "no_halt": false},
        "HaltezeitD": {"haltezeit": 1, "no_halt": false},
        "HaltezeitUncategorized": {"haltezeit": 0, "no_halt": true}
      },
      "symmetryAxis": null,
      "warnings": null,
      "labelIds": []
    },
    {
      "id": 4,
      "betriebspunktName": "ZF",
      "fullName": "Zofingen",
      "positionX": 832,
      "positionY": 448,
      "ports": [],
      "transitions": [],
      "connections": [],
      "resourceId": 5,
      "perronkanten": 5,
      "connectionTime": 3,
      "trainrunCategoryHaltezeiten": {
        "HaltezeitIPV": {"haltezeit": 3, "no_halt": false},
        "HaltezeitA": {"haltezeit": 2, "no_halt": false},
        "HaltezeitB": {"haltezeit": 2, "no_halt": false},
        "HaltezeitC": {"haltezeit": 1, "no_halt": false},
        "HaltezeitD": {"haltezeit": 1, "no_halt": false},
        "HaltezeitUncategorized": {"haltezeit": 0, "no_halt": true}
      },
      "symmetryAxis": null,
      "warnings": null,
      "labelIds": []
    },
    {
      "id": 5,
      "betriebspunktName": "ZG",
      "fullName": "Zug",
      "positionX": 1184,
      "positionY": 576,
      "ports": [],
      "transitions": [],
      "connections": [],
      "resourceId": 6,
      "perronkanten": 5,
      "connectionTime": 5,
      "trainrunCategoryHaltezeiten": {
        "HaltezeitIPV": {"haltezeit": 3, "no_halt": false},
        "HaltezeitA": {"haltezeit": 2, "no_halt": false},
        "HaltezeitB": {"haltezeit": 2, "no_halt": false},
        "HaltezeitC": {"haltezeit": 1, "no_halt": false},
        "HaltezeitD": {"haltezeit": 1, "no_halt": false},
        "HaltezeitUncategorized": {"haltezeit": 0, "no_halt": true}
      },
      "symmetryAxis": null,
      "warnings": null,
      "labelIds": []
    },
    {
      "id": 6,
      "betriebspunktName": "SS",
      "fullName": "Sursee",
      "positionX": 672,
      "positionY": 800,
      "ports": [],
      "transitions": [],
      "connections": [],
      "resourceId": 7,
      "perronkanten": 5,
      "connectionTime": 6,
      "trainrunCategoryHaltezeiten": {
        "HaltezeitIPV": {"haltezeit": 3, "no_halt": false},
        "HaltezeitA": {"haltezeit": 2, "no_halt": false},
        "HaltezeitB": {"haltezeit": 2, "no_halt": false},
        "HaltezeitC": {"haltezeit": 1, "no_halt": false},
        "HaltezeitD": {"haltezeit": 1, "no_halt": false},
        "HaltezeitUncategorized": {"haltezeit": 0, "no_halt": true}
      },
      "symmetryAxis": null,
      "warnings": null,
      "labelIds": []
    },
    {
      "id": 7,
      "betriebspunktName": "RTR",
      "fullName": "Rothrist",
      "positionX": 320,
      "positionY": 32,
      "ports": [],
      "transitions": [],
      "connections": [],
      "resourceId": 8,
      "perronkanten": 5,
      "connectionTime": 5,
      "trainrunCategoryHaltezeiten": {
        "HaltezeitIPV": {"haltezeit": 3, "no_halt": false},
        "HaltezeitA": {"haltezeit": 2, "no_halt": false},
        "HaltezeitB": {"haltezeit": 2, "no_halt": false},
        "HaltezeitC": {"haltezeit": 1, "no_halt": false},
        "HaltezeitD": {"haltezeit": 1, "no_halt": false},
        "HaltezeitUncategorized": {"haltezeit": 0, "no_halt": true}
      },
      "symmetryAxis": null,
      "warnings": null,
      "labelIds": []
    },
    {
      "id": 8,
      "betriebspunktName": "LTH",
      "fullName": "Langenthal",
      "positionX": 320,
      "positionY": 192,
      "ports": [],
      "transitions": [],
      "connections": [],
      "resourceId": 9,
      "perronkanten": 5,
      "connectionTime": 5,
      "trainrunCategoryHaltezeiten": {
        "HaltezeitIPV": {"haltezeit": 3, "no_halt": false},
        "HaltezeitA": {"haltezeit": 2, "no_halt": false},
        "HaltezeitB": {"haltezeit": 2, "no_halt": false},
        "HaltezeitC": {"haltezeit": 1, "no_halt": false},
        "HaltezeitD": {"haltezeit": 1, "no_halt": false},
        "HaltezeitUncategorized": {"haltezeit": 0, "no_halt": true}
      },
      "symmetryAxis": null,
      "warnings": null,
      "labelIds": []
    },
    {
      "id": 9,
      "betriebspunktName": "BAA",
      "fullName": "Baar",
      "positionX": 1536,
      "positionY": 480,
      "ports": [],
      "transitions": [],
      "connections": [],
      "resourceId": 10,
      "perronkanten": 5,
      "connectionTime": 5,
      "trainrunCategoryHaltezeiten": {
        "HaltezeitIPV": {"haltezeit": 3, "no_halt": false},
        "HaltezeitA": {"haltezeit": 2, "no_halt": false},
        "HaltezeitB": {"haltezeit": 2, "no_halt": false},
        "HaltezeitC": {"haltezeit": 1, "no_halt": false},
        "HaltezeitD": {"haltezeit": 1, "no_halt": false},
        "HaltezeitUncategorized": {"haltezeit": 0, "no_halt": true}
      },
      "symmetryAxis": null,
      "warnings": null,
      "labelIds": []
    },
    {
      "id": 10,
      "betriebspunktName": "GD",
      "fullName": "Goldau",
      "positionX": 1728,
      "positionY": 960,
      "ports": [],
      "transitions": [],
      "connections": [],
      "resourceId": 11,
      "perronkanten": 5,
      "connectionTime": 5,
      "trainrunCategoryHaltezeiten": {
        "HaltezeitIPV": {"haltezeit": 3, "no_halt": false},
        "HaltezeitA": {"haltezeit": 2, "no_halt": false},
        "HaltezeitB": {"haltezeit": 2, "no_halt": false},
        "HaltezeitC": {"haltezeit": 1, "no_halt": false},
        "HaltezeitD": {"haltezeit": 1, "no_halt": false},
        "HaltezeitUncategorized": {"haltezeit": 0, "no_halt": true}
      },
      "symmetryAxis": null,
      "warnings": null,
      "labelIds": []
    }
  ],
  "trainrunSections": [],
  "trainruns": [],
  "resources": [
    {"id": 1, "capacity": 2},
    {"id": 2, "capacity": 2},
    {"id": 3, "capacity": 2},
    {"id": 4, "capacity": 2},
    {"id": 5, "capacity": 2},
    {"id": 6, "capacity": 2},
    {"id": 7, "capacity": 2},
    {"id": 8, "capacity": 2},
    {"id": 9, "capacity": 2},
    {"id": 10, "capacity": 2},
    {"id": 11, "capacity": 2}
  ],
  "metadata": {
    "analyticsSettings": {"originDestinationSettings": {"connectionPenalty": 5}},
    "trainrunCategories": [
      {
        "id": 0,
        "order": 0,
        "shortName": "EC",
        "name": "International",
        "colorRef": "EC",
        "fachCategory": "HaltezeitIPV",
        "minimalTurnaroundTime": 4,
        "nodeHeadwayStop": 2,
        "nodeHeadwayNonStop": 2,
        "sectionHeadway": 2
      },
      {
        "id": 1,
        "order": 1,
        "shortName": "IC",
        "name": "InterCity",
        "colorRef": "IC",
        "fachCategory": "HaltezeitA",
        "minimalTurnaroundTime": 4,
        "nodeHeadwayStop": 2,
        "nodeHeadwayNonStop": 2,
        "sectionHeadway": 2
      },
      {
        "id": 2,
        "order": 2,
        "shortName": "IR",
        "name": "InterRegio",
        "colorRef": "IR",
        "fachCategory": "HaltezeitB",
        "minimalTurnaroundTime": 4,
        "nodeHeadwayStop": 2,
        "nodeHeadwayNonStop": 2,
        "sectionHeadway": 2
      },
      {
        "id": 3,
        "order": 3,
        "shortName": "RE",
        "name": "RegioExpress",
        "colorRef": "RE",
        "fachCategory": "HaltezeitC",
        "minimalTurnaroundTime": 4,
        "nodeHeadwayStop": 2,
        "nodeHeadwayNonStop": 2,
        "sectionHeadway": 2
      },
      {
        "id": 4,
        "order": 4,
        "shortName": "S",
        "name": "RegioUndSBahnverkehr",
        "colorRef": "S",
        "fachCategory": "HaltezeitD",
        "minimalTurnaroundTime": 4,
        "nodeHeadwayStop": 2,
        "nodeHeadwayNonStop": 2,
        "sectionHeadway": 2
      },
      {
        "id": 5,
        "order": 5,
        "shortName": "GEX",
        "name": "GüterExpress",
        "colorRef": "GEX",
        "fachCategory": "HaltezeitUncategorized",
        "minimalTurnaroundTime": 4,
        "nodeHeadwayStop": 3,
        "nodeHeadwayNonStop": 3,
        "sectionHeadway": 3
      },
      {
        "id": 6,
        "order": 6,
        "shortName": "G",
        "name": "Güterverkehr",
        "colorRef": "G",
        "fachCategory": "HaltezeitUncategorized",
        "minimalTurnaroundTime": 4,
        "nodeHeadwayStop": 3,
        "nodeHeadwayNonStop": 3,
        "sectionHeadway": 3
      }
    ],
    "trainrunFrequencies": [
      {
        "id": 0,
        "order": 0,
        "frequency": 15,
        "offset": 0,
        "shortName": "15",
        "name": "verkehrt viertelstündlich",
        "linePatternRef": "15"
      },
      {
        "id": 1,
        "order": 0,
        "frequency": 20,
        "offset": 0,
        "shortName": "20",
        "name": "verkehrt im 20 Minuten Takt",
        "linePatternRef": "20"
      },
      {
        "id": 2,
        "order": 0,
        "frequency": 30,
        "offset": 0,
        "shortName": "30",
        "name": "verkehrt halbstündlich",
        "linePatternRef": "30"
      },
      {
        "id": 3,
        "order": 0,
        "frequency": 60,
        "offset": 0,
        "shortName": "60",
        "name": "verkehrt stündlich",
        "linePatternRef": "60"
      },
      {
        "id": 4,
        "order": 0,
        "frequency": 120,
        "offset": 0,
        "shortName": "120",
        "name": "verkehrt zweistündlich (gerade)",
        "linePatternRef": "120"
      },
      {
        "id": 5,
        "order": 0,
        "frequency": 120,
        "offset": 60,
        "shortName": "120+",
        "name": "verkehrt zweistündlich (ungerade)",
        "linePatternRef": "120"
      }
    ],
    "trainrunTimeCategories": [
      {
        "id": 0,
        "order": 0,
        "shortName": "7/24",
        "name": "verkehrt uneingeschränkt",
        "dayTimeInterval": [],
        "weekday": [1, 2, 3, 4, 5, 6, 7],
        "linePatternRef": "7/24"
      },
      {
        "id": 1,
        "order": 0,
        "shortName": "HVZ",
        "name": "verkehrt zur Hauptverkehrszeit",
        "dayTimeInterval": [
          {"from": 360, "to": 420},
          {"from": 960, "to": 1140}
        ],
        "weekday": [1, 2, 3, 4, 5, 6, 7],
        "linePatternRef": "HVZ"
      },
      {
        "id": 2,
        "order": 0,
        "shortName": "zeitweise",
        "name": "verkehrt zeitweise",
        "dayTimeInterval": [],
        "weekday": [],
        "linePatternRef": "ZEITWEISE"
      }
    ],
    "netzgrafikColors": [
      {
        "id": 2,
        "colorRef": "NORMAL",
        "color": "#767676",
        "colorFocus": "#000000",
        "colorMuted": "#DCDCDC",
        "colorRelated": "#767676",
        "colorDarkMode": "#767676",
        "colorDarkModeFocus": "#DCDCDC",
        "colorDarkModeMuted": "#000000",
        "colorDarkModeRelated": "#767676"
      }
    ],
    "orderingAlgorithm": 0,
    "trafficSide": "leftHand"
  },
  "freeFloatingTexts": [],
  "labels": [],
  "labelGroups": [],
  "filterData": {"filterSettings": []}
}
